// not deleting until happy v2 is working - allows for quick reversal
// export { default } from '@/components/DealsPage';

/* eslint-disable react/jsx-props-no-spreading */
import type { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
// eslint-disable-next-line no-use-before-define
import React from 'react';

import { logger } from '@shared/utils';

import { Meta } from '@/v2/components/global/Meta';
import { CampaignView } from '@/v2/components/pages/CampaignView';
import { getCampaignPage } from '@/v2/services/bff/getCampaignPage';

export const getStaticProps = async ({ preview }: GetStaticPropsContext) => {
  try {
    const props = await getCampaignPage({
      preview,
      slug: 'deals',
    });

    return {
      props,
      // set static deals page regeneration -> 120 seconds;
      revalidate: 120,
    };
  } catch (error) {
    logger.error(error);
    return {
      props: {} as Awaited<ReturnType<typeof getCampaignPage>>,
      revalidate: 120,
      notFound: true,
    };
  }
};

const DealsPage = ({
  meta,
  campaign,
  destinations,
  tiles,
  ...rest
}: InferGetStaticPropsType<typeof getStaticProps>) => (
  <>
    <Meta {...meta} />
    <CampaignView
      campaign={campaign}
      destinations={destinations}
      tiles={tiles}
      {...rest}
    />
  </>
);

export default DealsPage;
